export default "__VITE_ASSET__kfxbjmtK__"